export const regionCityOptions: { [key: string]: string[] } = {
  Благоевград: [
    'Абланица',
    'Банско',
    'Баня',
    'Бачево',
    'Беласица  ',
    'Белица',
    'Благоевград',
    'Борово',
    'Брезница',
    'Вълкосел',
    'Гоце Делчев',
    'Гърмен',
    'Дамяница',
    'Дебрен',
    'Добринище',
    'Дъбница',
    'Кавракирово',
    'Коларово',
    'Корница',
    'Кочан',
    'Краище',
    'Кресна',
    'Крупник',
    'Кърналово',
    'Лъжница',
    'Мелник',
    'Микрево',
    'Мусомища',
    'Огняново',
    'Петрич',
    'Плетена',
    'Първомай',
    'Разлог',
    'Рибново',
    'Сандански',
    'Сатовча',
    'Симитли',
    'Слащен',
    'Хаджидимово',
    'Якоруда',
  ],
  Бургас: [
    'Айтос',
    'Ахелой',
    'Ахтопол',
    'Бата',
    'Бургас',
    'Българово',
    'Гълъбец',
    'Гюльовца',
    'Дебелт',
    'Добромир',
    'Дюни',
    'Елените',
    'Зайчар',
    'Зидарово',
    'Каблешково',
    'Камено',
    'Карагеоргиево',
    'Карнобат',
    'Китен',
    'Кошарица',
    'Люляково',
    'Малко Търново',
    'Манолич',
    'Несебър',
    'Обзор',
    'Оризаре',
    'Планиница',
    'Поморие',
    'Приморско',
    'Равда',
    'Рудник',
    'Руен',
    'Свети Влас',
    'Слънчев бряг',
    'Созопол',
    'Средец',
    'Сунгурларе',
    'Царево',
    'Черно море',
    'Черноморец',
  ],
  Варна: [
    'Аксаково',
    'Белоградец',
    'Белослав',
    'Блъсково',
    'Бозвелийско',
    'Бяла',
    'Варна',
    'Въглен',
    'Вълчи дол',
    'Горен чифлик',
    'Гроздьово',
    'Девня',
    'Долни чифлик',
    'Дъбравино',
    'Дългопол',
    'Езерово',
    'Звездица',
    'Златни пясъци',
    'Игнатиево',
    'Кабакум',
    'Каменар',
    'Камчия',
    'Кичево',
    'Константиново',
    'Любен Каравелово',
    'Манастирски рид',
    'Медовец',
    'Партизани',
    'Перчемлията',
    'Приселци',
    'Провадия',
    'Пчелник',
    'Св.Св. Константин и Елена',
    'Синдел',
    'Слънчев ден',
    'Старо Оряхово',
    'Суворово',
    'Тополи',
    'Цонево',
    'Чернево',
  ],
  'Велико Търново': [
    'Алеково',
    'Александър Стамболийски',
    'Асеново',
    'Балван',
    'Батак',
    'Беляковец',
    'Бутово',
    'Българско Сливово',
    'Бяла черква',
    'Велико Търново',
    'Върбица',
    'Върбовка',
    'Горна Оряховица',
    'Дебелец',
    'Джулюница',
    'Долна Оряховица',
    'Драганово',
    'Елена',
    'Златарица',
    'Камен',
    'Кесарево',
    'Килифарево',
    'Козловец',
    'Константин',
    'Лясковец',
    'Недан',
    'Овча могила',
    'Ореш',
    'Павликени',
    'Петко Каравелово',
    'Поликраище',
    'Полски Тръмбеш',
    'Първомайци',
    'Раданово',
    'Ресен',
    'Самоводене',
    'Свищов',
    'Стражица',
    'Сухиндол',
    'Царевец',
  ],
  Видин: [
    'Антимово',
    'Арчар',
    'Балей',
    'Бела',
    'Бела Рада',
    'Бело поле',
    'Белоградчик',
    'Бойница',
    'Бориловец',
    'Боровица',
    'Брегово',
    'Буковец',
    'Видин',
    'Винарово',
    'Воднянци',
    'Връв',
    'Гайтанци',
    'Гара Орешец',
    'Генерал Мариново',
    'Големаново',
    'Гомотарци',
    'Горни Лом',
    'Градец',
    'Грамада',
    'Гъмзово',
    'Гюргич',
    'Димово',
    'Дреновец',
    'Дунавци',
    'Иново',
    'Капитановци',
    'Кула',
    'Кутово',
    'Неговановци',
    'Ново село',
    'Новоселци',
    'Покрайна',
    'Ружинци',
    'Сланотрън',
    'Чупрене',
  ],
  Враца: [
    'Алтимир',
    'Баница',
    'Бели извор',
    'Боденец',
    'Борован',
    'Бутан',
    'Бърдарски геран',
    'Бъркачево',
    'Бяла Слатина',
    'Враца',
    'Габаре',
    'Галатин',
    'Галиче',
    'Гложене',
    'Голямо Пещене',
    'Девене',
    'Добролево',
    'Долна Кремена',
    'Зверино',
    'Згориград',
    'Игнатица',
    'Камено поле',
    'Козлодуй',
    'Костелево',
    'Криводол',
    'Крушовица',
    'Малорад',
    'Мездра',
    'Мизия',
    'Михайлово',
    'Оряхово',
    'Остров',
    'Попица',
    'Роман',
    'Селановци',
    'Софрониево',
    'Търнава',
    'Търнак',
    'Хайредин',
    'Хърлец',
  ],
  Габрово: [
    'Агатово',
    'Александър Стамболийски',
    'Батошево',
    'Бериево',
    'Богатово',
    'Борики',
    'Буря',
    'Враниловци',
    'Габрово',
    'Ганчовец',
    'Гергини',
    'Горна Росица',
    'Гостилица',
    'Градище',
    'Градница',
    'Гъбене',
    'Дамяново',
    'Добромирка',
    'Донино',
    'Драгановци',
    'Дряново',
    'Душево',
    'Жълтеш',
    'Идилево',
    'Киевци',
    'Кормянско',
    'Крамолин',
    'Крушево',
    'Кръвеник',
    'Ловнидол',
    'Малки Вършец',
    'Младен',
    'Петко Славейков',
    'Плачковци',
    'Поповци',
    'Ряховците',
    'Севлиево',
    'Сенник',
    'Трявна',
    'Царева ливада',
  ],
  Добрич: [
    'Албена',
    'Балчик',
    'Батово',
    'Безмер',
    'Бенковски',
    'Божан',
    'Божурово',
    'Българево',
    'Ведрина',
    'Генерал Тошево',
    'Добрич',
    'Дончево',
    'Жегларци',
    'Зърнево',
    'Каблешково',
    'Каварна',
    'Карапелит',
    'Кардам',
    'Коларци',
    'Кранево',
    'Крушари',
    'Ловчанци',
    'Лозенец',
    'Люляково',
    'Оброчище',
    'Одърци',
    'Орляк',
    'Паскалево',
    'Плачидол',
    'Победа',
    'Попгруево',
    'Сенокос',
    'Соколово',
    'Спасово',
    'Стефаново',
    'Стожер',
    'Тервел',
    'Фелдфебел Денково',
    'Черна',
    'Шабла',
  ],
  Кърджали: [
    'Аврен',
    'Айрово',
    'Ардино',
    'Бенковски',
    'Бял извор',
    'Вранско',
    'Габрово',
    'Глухар',
    'Горно Кирково',
    'Горски извор',
    'Груево',
    'Джебел',
    'Дрангово',
    'Егрек',
    'Жълтуша',
    'Звънарка',
    'Кирково',
    'Комунига',
    'Крумовград',
    'Кърджали',
    'Кърджали',
    'Лясково',
    'Момчилград',
    'Мост',
    'Опълченско',
    'Падина',
    'Пелин',
    'Перперек',
    'Полковник Желязово',
    'Припек',
    'Рани лист',
    'Резбарци',
    'Странджево',
    'Стремци',
    'Студен Кладенец',
    'Тихомир',
    'Фотиново',
    'Чакаларово',
    'Чорбаджийско',
    'Широко поле',
  ],
  Кюстендил: [
    'Бабино',
    'Багренци',
    'Баланово',
    'Бараково',
    'Берсин',
    'Бистрица',
    'Блажиево',
    'Блатино',
    'Бобов дол',
    'Бобошево',
    'Богослов',
    'Бураново',
    'Ваксево',
    'Гирчевци',
    'Граница',
    'Джерман',
    'Дупница',
    'Жабокрът',
    'Жиленци',
    'Коняво',
    'Копиловци',
    'Кочериново',
    'Крайници',
    'Кюстендил',
    'Лозно',
    'Мламолово',
    'Невестино',
    'Овчарци',
    'Пиперков чифлик',
    'Ресилово',
    'Рила',
    'Самораново',
    'Сапарева баня',
    'Сапарево',
    'Слокощица',
    'Соволяно',
    'Стоб',
    'Червен брег',
    'Ябълково',
    'Яхиново',
  ],
  Ловеч: [
    'Александрово',
    'Априлци',
    'Баховица',
    'Бежаново',
    'Бели Осъм',
    'Борима',
    'Брестница',
    'Български извор',
    'Врабево',
    'Галата',
    'Глогово',
    'Гложене',
    'Голяма Желязна',
    'Горско Сливово',
    'Градежница',
    'Дебнево',
    'Дерманци',
    'Дойренци',
    'Златна Панега',
    'Калейца',
    'Карлуково',
    'Кирчево',
    'Лесидрен',
    'Летница',
    'Лисец',
    'Ловеч',
    'Луковит',
    'Малиново',
    'Орешак',
    'Петревене',
    'Рибарица',
    'Румянцево',
    'Славяни',
    'Слатина',
    'Сопот',
    'Тетевен',
    'Торос',
    'Троян',
    'Угърчин',
    'Ябланица',
  ],
  Монтана: [
    'Берковица',
    'Благово',
    'Бойчиновци',
    'Боровци',
    'Брусарци',
    'Бързия',
    'Василовци',
    'Владимирово',
    'Вълчедръм',
    'Вършец',
    'Габровница',
    'Георги Дамяново',
    'Громшин',
    'Доктор Йосифово',
    'Долни Цибър',
    'Долно Белотинци',
    'Долно Церовене',
    'Дългоделци',
    'Ерден',
    'Замфир',
    'Замфирово',
    'Златия',
    'Ковачица',
    'Комощица',
    'Копиловци',
    'Крива бара',
    'Лехчево',
    'Лом',
    'Мадан',
    'Медковец',
    'Мокреш',
    'Монтана',
    'Мърчево',
    'Разград',
    'Расово',
    'Септемврийци',
    'Смоляновци',
    'Сталийска махала',
    'Чипровци',
    'Якимово',
  ],
  Пазарджик: [
    'Алеко Константиново',
    'Батак',
    'Белово',
    'Братаница',
    'Брацигово',
    'Бъта',
    'Бяга',
    'Варвара',
    'Велинград',
    'Ветрен',
    'Ветрен дол',
    'Виноградец',
    'Главиница',
    'Говедаре',
    'Грашево',
    'Динката',
    'Добровница',
    'Дорково',
    'Драгиново',
    'Звъничево',
    'Ивайло',
    'Исперихово',
    'Ковачево',
    'Костандово',
    'Мало Конаре',
    'Мокрище',
    'Нова махала',
    'Огняново',
    'Пазарджик',
    'Панагюрище',
    'Пещера',
    'Попинци',
    'Ракитово',
    'Света Петка',
    'Семчиново',
    'Септември',
    'Синитово',
    'Стрелча',
    'Сърница',
    'Черногорово',
  ],
  Перник: [
    'Батановци',
    'Бегуновци',
    'Богданов дол',
    'Боснек',
    'Брезник',
    'Велковци',
    'Витановци',
    'Владимир',
    'Гигинци',
    'Главановци',
    'Големо Бучино',
    'Горна Диканя',
    'Гълъбник',
    'Дебели лаг',
    'Дивля',
    'Дивотино',
    'Долна Диканя',
    'Долна Секирна',
    'Долни Раковец',
    'Драгичево',
    'Дрен',
    'Друган',
    'Егълница',
    'Еловдол',
    'Житуша',
    'Земен',
    'Извор',
    'Калище',
    'Кладница',
    'Кралев дол',
    'Люлин',
    'Мещица',
    'Ноевци',
    'Перник',
    'Пчелина',
    'Радомир',
    'Рударци',
    'Студена',
    'Трън',
    'Ярджиловци',
  ],
  Плевен: [
    'Асеновци',
    'Белене',
    'Божурица',
    'Бреница',
    'Брест',
    'Брестовец',
    'Буковлък',
    'Гиген',
    'Глава',
    'Горна Митрополия',
    'Горни Дъбник',
    'Горник',
    'Градище',
    'Гривица',
    'Гулянци',
    'Долна Митрополия',
    'Долни Дъбник',
    'Долни Луковит',
    'Искър',
    'Кнежа',
    'Койнаре',
    'Комарево',
    'Крушовица',
    'Левски',
    'Малчика',
    'Милковица',
    'Никопол',
    'Новачене',
    'Обнова',
    'Опанец',
    'Ореховица',
    'Петърница',
    'Плевен',
    'Пордим',
    'Садовец',
    'Славяново',
    'Ставерци',
    'Тръстеник',
    'Червен бряг',
    'Ясен',
  ],
  Пловдив: [
    'Асеновград',
    'Баня',
    'Белащица',
    'Белозем',
    'Болярци',
    'Боянци',
    'Браниполе',
    'Брезово',
    'Брестник',
    'Брестовица',
    'Войводиново',
    'Градина',
    'Граф Игнатиево',
    'Дъбене',
    'Дълго поле',
    'Йоаким Груево',
    'Калековец',
    'Калофер',
    'Калояново',
    'Карлово',
    'Катуница',
    'Клисура',
    'Костиево',
    'Кричим',
    'Крумово',
    'Куклен',
    'Куртово Конаре',
    'Лъки',
    'Маноле',
    'Марково',
    'Ново село',
    'Перущица',
    'Пловдив',
    'Първенец',
    'Първомай',
    'Раковски',
    'Сопот',
    'Стамболийски',
    'Съединение',
    'Хисаря',
  ],
  Разград: [
    'Бели Лом',
    'Беловец',
    'Бисерци',
    'Благоево',
    'Брестовене',
    'Вазово',
    'Веселец',
    'Веселина',
    'Владимировци',
    'Гецово',
    'Голям Поровец',
    'Дряновец',
    'Духовец',
    'Дянково',
    'Езерче',
    'Желязковец',
    'Завет',
    'Звънарци',
    'Исперих',
    'Йонково',
    'Китанчево',
    'Киченица',
    'Кубрат',
    'Липник',
    'Ловско',
    'Лозница',
    'Лудогорци',
    'Лъвино',
    'Мортагоново',
    'Мъдрево',
    'Ножарово',
    'Острово',
    'Подайва',
    'Разград',
    'Раковски',
    'Самуил',
    'Севар',
    'Стражец',
    'Цар Калоян',
    'Ясеновец',
  ],
  Русе: [
    'Баниска',
    'Басарбово',
    'Батин',
    'Батишница',
    'Борисово',
    'Борово',
    'Босилковци',
    'Бъзовец',
    'Бъзън',
    'Бяла',
    'Ветово',
    'Глоджево',
    'Голямо Враново',
    'Горно Абланово',
    'Две могили',
    'Долна Студена',
    'Дряновец',
    'Иваново',
    'Караманово',
    'Кацелово',
    'Копривец',
    'Кошарна',
    'Красен',
    'Мартен',
    'Николово',
    'Ново село',
    'Обретеник',
    'Пиргово',
    'Полско Косово',
    'Русе',
    'Ряхово',
    'Сандрово',
    'Сеново',
    'Сливо поле',
    'Смирненски',
    'Тетово',
    'Тръстеник',
    'Ценово',
    'Червена вода',
    'Щръклево',
  ],
  Силистра: [
    'Айдемир',
    'Алфатар',
    'Бабук',
    'Белица',
    'Богданци',
    'Боил',
    'Брадвари',
    'Водно',
    'Вокил',
    'Главиница',
    'Голеш',
    'Дулово',
    'Зафирово',
    'Зебил',
    'Златоклас',
    'Искра',
    'Йорданово',
    'Кайнарджа',
    'Калипетрово',
    'Калугерене',
    'Колобър',
    'Любен',
    'Межден',
    'Нова Черна',
    'Овен',
    'Окорш',
    'Паисиево',
    'Попина',
    'Поройно',
    'Правда',
    'Професор Иширково',
    'Раздел',
    'Руйно',
    'Силистра',
    'Средище',
    'Тутракан',
    'Цар Самуил',
    'Черник',
    'Чернолик',
    'Яребица',
  ],
  Сливен: [
    'Асеновец',
    'Баня',
    'Блатец',
    'Бяла',
    'Бяла паланка',
    'Гавраилово',
    'Гергевец',
    'Глуфишево',
    'Горно Александрово',
    'Градец',
    'Драгоданово',
    'Желю войвода',
    'Злати войвода',
    'Калояново',
    'Камен',
    'Караново',
    'Кермен',
    'Кипилово',
    'Ковачите',
    'Коньово',
    'Кортен',
    'Котел',
    'Крушаре',
    'Любенова махала',
    'Малко село',
    'Младово',
    'Млекарево',
    'Мокрен',
    'Нова Загора',
    'Новачево',
    'Самуилово',
    'Сборище',
    'Селиминово',
    'Сливен',
    'Сотиря',
    'Твърдица',
    'Тополчане',
    'Чинтулово',
    'Шивачево',
    'Ябланово',
  ],
  Смолян: [
    'Аламовци',
    'Арда',
    'Баните',
    'Барутин',
    'Беден',
    'Борино',
    'Бръщен',
    'Върбина',
    'Грохотно',
    'Гълъбово',
    'Гьоврен',
    'Давидково',
    'Девин',
    'Долен',
    'Доспат',
    'Доспат',
    'Елховец',
    'Ерма река',
    'Златоград',
    'Змеица',
    'Късак',
    'Любча',
    'Лясково',
    'Мадан',
    'Момчиловци',
    'Неделино',
    'Оряховец',
    'Павелско',
    'Пампорово',
    'Рудозем',
    'Селча',
    'Смилян',
    'Смолян',
    'Средногорци',
    'Старцево',
    'Триград',
    'Търън',
    'Црънча',
    'Чепеларе',
    'Чепинци',
  ],
  'София град': [
    'Балша',
    'Банкя',
    'Бистрица',
    'Бусманци',
    'Бухово',
    'Владая',
    'Войнеговци',
    'Волуяк',
    'Герман',
    'Горни Богров',
    'Доброславци',
    'Долни Богров',
    'Долни Пасарел',
    'Железница',
    'Желява',
    'Житен',
    'Иваняне',
    'Искър',
    'Казичене',
    'Клисура',
    'Кокаляне',
    'Кривина',
    'Кубратово',
    'Кътина',
    'Лозен',
    'Локорско',
    'Мало Бучино',
    'Мировяне',
    'Мрамор',
    'Мърчаево',
    'Негован',
    'Нови Искър',
    'Панчарево',
    'Подгумер',
    'Световрачене',
    'София',
    'Чепинци',
    'Щъркелово гнездо',
    'Яна',
    'Ярема',
  ],
  'София област': [
    'Алдомировци',
    'Антон',
    'Априлово',
    'Божурище',
    'Боровец',
    'Ботевград',
    'Вакарел',
    'Владо Тричков',
    'Врачеш',
    'Габра',
    'Гара Бов',
    'Гара Елин Пелин',
    'Гара Лакатник',
    'Говедарци',
    'Годеч',
    'Долна баня',
    'Драгоман',
    'Елин Пелин',
    'Етрополе',
    'Златица',
    'Искрец',
    'Ихтиман',
    'Копривщица',
    'Костенец',
    'Костенец',
    'Костинброд',
    'Лесново',
    'Литаково',
    'Мирково',
    'Момин проход',
    'Нови хан',
    'Петърч',
    'Пирдоп',
    'Правец',
    'Самоков',
    'Своге',
    'Скравена',
    'Сливница',
    'Трудовец',
    'Церово',
  ],

  'Стара Загора': [
    'Александрово',
    'Богомилово',
    'Бузовград',
    'Ветрен',
    'Габарево',
    'Горно Сахране',
    'Горно Черковище',
    'Гурково',
    'Гълъбово',
    'Дъбово',
    'Дълбоки',
    'Енина',
    'Зетьово',
    'Казанлък',
    'Копринка',
    'Крън',
    'Кънчево',
    'Мъглиж',
    'Николаево',
    'Обручище',
    'Овощник',
    'Оризово',
    'Осетеново',
    'Павел баня',
    'Паничерево',
    'Раднево',
    'Розово',
    'Ръжена',
    'Свобода',
    'Стара Загора',
    'Сърнево',
    'Тулово',
    'Тъжа',
    'Хаджидимитрово',
    'Хан Аспарухово',
    'Хрищени',
    'Черна гора',
    'Чирпан',
    'Шейново',
    'Шипка',
  ],

  Търговище: [
    'Антоново',
    'Баячево',
    'Беломорци',
    'Буховци',
    'Вардун',
    'Водица',
    'Врани кон',
    'Гагово',
    'Голямо градище',
    'Голямо ново',
    'Гърчиново',
    'Зараево',
    'Звездица',
    'Зелена морава',
    'Камбурово',
    'Кардам',
    'Ковачевец',
    'Козма презвитер',
    'Кралево',
    'Крепча',
    'Лиляк',
    'Ломци',
    'Макариополско',
    'Медовина',
    'Обител',
    'Овчарово',
    'Омуртаг',
    'Опака',
    'Плъстина',
    'Подгорица',
    'Попово',
    'Пъдарино',
    'Руец',
    'Садина',
    'Светлен',
    'Славяново',
    'Стража',
    'Трескавец',
    'Търговище',
    'Церовище',
  ],
  Хасково: [
    'Бисер',
    'Боян Ботево',
    'Брод',
    'Войводово',
    'Въгларово',
    'Гарваново',
    'Горски извор',
    'Димитровград',
    'Динево',
    'Добрич',
    'Жълти бряг',
    'Ивайловград',
    'Ивайловград',
    'Капитан Андреево',
    'Караманци',
    'Книжовник',
    'Конуш',
    'Крепост',
    'Криво поле',
    'Любимец',
    'Маджарово',
    'Малево',
    'Малко градище',
    'Меричлери',
    'Минерални бани',
    'Момково',
    'Орешник',
    'Радиево',
    'Радовец',
    'Свиленград',
    'Симеоновград',
    'Скобелево',
    'Славяново',
    'Стамболийски',
    'Стамболово',
    'Тополовград',
    'Узунджово',
    'Харманли',
    'Хасково',
    'Ябълково',
  ],
  Шумен: [
    'Борци',
    'Браничево',
    'Бяла река',
    'Велики Преслав',
    'Венец',
    'Веселиново',
    'Вехтово',
    'Вълнари',
    'Върбица',
    'Градище',
    'Гусла',
    'Дибич',
    'Драгоево',
    'Друмево',
    'Живково',
    'Загориче',
    'Златар',
    'Златна нива',
    'Ивански',
    'Изгрев',
    'Каолиново',
    'Каспичан',
    'Каспичан',
    'Климент',
    'Кочово',
    'Крива река',
    'Лятно',
    'Мадара',
    'Марково',
    'Нови пазар',
    'Памукчии',
    'Пет могили',
    'Плиска',
    'Смядово',
    'Тича',
    'Тодор Икономово',
    'Хитрино',
    'Царев брод',
    'Шумен',
    'Ясенково',
  ],
  Ямбол: [
    'Александрово',
    'Атолово',
    'Безмер',
    'Болярово',
    'Болярско',
    'Ботево',
    'Бояджик',
    'Бояново',
    'Веселиново',
    'Воден',
    'Воденичане',
    'Войника',
    'Генерал Инзово',
    'Генерал Тошево',
    'Голям манастир',
    'Голямо Крушево',
    'Гранитово',
    'Гълъбинци',
    'Дражево',
    'Елхово',
    'Завой',
    'Зимница',
    'Изгрев',
    'Кабиле',
    'Крумово',
    'Кукорево',
    'Лесово',
    'Лозенец',
    'Маломир',
    'Окоп',
    'Победа',
    'Роза',
    'Скалица',
    'Стефан Караджово',
    'Стралджа',
    'Тенево',
    'Хаджидимитрово',
    'Ханово',
    'Чарган',
    'Ямбол',
  ],
};
